import { render } from "./CommonLayout.vue?vue&type=template&id=eb33073e&ts=true"
import script from "./CommonLayout.vue?vue&type=script&lang=ts"
export * from "./CommonLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__